import script from "./SideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBar.vue?vue&type=script&setup=true&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=712f0ade&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712f0ade"]])

export default __exports__